module.exports = __webpack_public_path__ + "static/media/sdg_icon_5.1a061f3c.png";